// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 105px;
  padding: 0;
}

.header-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-right: var(--spacing-xl);
  cursor: pointer;
}

.header-logo img {
  height: 95px;
  width: auto;
}


.header-search {
  flex: 1 1;
  max-width: 640px;
  margin: 0 var(--spacing-xl);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 25px;
}

.categories-container {
  display: flex;
  gap: 15px;
  padding-bottom: 6px;
  align-items: center;
  flex-wrap: nowrap;
  overflow: visible;
  white-space: nowrap;
}

.category-item {
  flex: 0 0 auto;
}

.category-item {
  flex: 0 0 auto;
}

@media (max-width: 768px) {
  .header-container {
    height: auto;
    flex-wrap: wrap;
    padding: 10px 0;
    gap: 10px;
  }

  .categories-container {
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .categories-container::-webkit-scrollbar {
    display: none;
  }

  .header-logo {
    margin-right: 0;
  }
  
  .header-logo img {
    height: 85px; /* Larger logo on mobile */
  }

  .header-actions {
    gap: 15px;
  }

  /* Force search bar to take full width on a new line */
  .header-search {
    flex: 1 1 100%;
    max-width: 100%;
    margin: 0;
    order: 3; /* Move to the end */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;;AAGA;EACE,SAAO;EACP,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY,EAAE,0BAA0B;EAC1C;;EAEA;IACE,SAAS;EACX;;EAEA,sDAAsD;EACtD;IACE,cAAc;IACd,eAAe;IACf,SAAS;IACT,QAAQ,EAAE,oBAAoB;EAChC;AACF","sourcesContent":[".header-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 105px;\n  padding: 0;\n}\n\n.header-logo {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  margin-right: var(--spacing-xl);\n  cursor: pointer;\n}\n\n.header-logo img {\n  height: 95px;\n  width: auto;\n}\n\n\n.header-search {\n  flex: 1;\n  max-width: 640px;\n  margin: 0 var(--spacing-xl);\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n}\n\n.categories-container {\n  display: flex;\n  gap: 15px;\n  padding-bottom: 6px;\n  align-items: center;\n  flex-wrap: nowrap;\n  overflow: visible;\n  white-space: nowrap;\n}\n\n.category-item {\n  flex: 0 0 auto;\n}\n\n.category-item {\n  flex: 0 0 auto;\n}\n\n@media (max-width: 768px) {\n  .header-container {\n    height: auto;\n    flex-wrap: wrap;\n    padding: 10px 0;\n    gap: 10px;\n  }\n\n  .categories-container {\n    overflow-x: auto;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  .categories-container::-webkit-scrollbar {\n    display: none;\n  }\n\n  .header-logo {\n    margin-right: 0;\n  }\n  \n  .header-logo img {\n    height: 85px; /* Larger logo on mobile */\n  }\n\n  .header-actions {\n    gap: 15px;\n  }\n\n  /* Force search bar to take full width on a new line */\n  .header-search {\n    flex: 1 1 100%;\n    max-width: 100%;\n    margin: 0;\n    order: 3; /* Move to the end */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
